import { useState } from 'react';
import { useNavigate } from 'react-router';
import {
  BidTrophy,
  Column,
  Row,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useGetBidHistory } from '~/domain/BestInDental';
import { FixedWidthScreen } from '~/commonComponents/FixedWidthScreen';
import { Pagination } from '~/commonComponents/Pagination/Pagination';
import { routes } from '~/routes';
import { BidErrorState, BidLoadingState, WinnersToolkitButton } from '../shared';
import { BidHistoryRow } from './components/BidHistoryRow';
import styles from './BidPage.module.css';

const PAGE_DESCRIPTION =
  "Best in Dental is GoTu's annual recognition program honoring professionals and offices who set the standard for quality, reliability and care. Recognition is earned through real performance, never bought.";

const BidPage = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const { items, toolkitEligible, totalPages, isLoading, isError, refetch } =
    useGetBidHistory(page);

  if (isLoading) {
    return <BidLoadingState data-cy="bid-page-loading" />;
  }

  if (isError) {
    return (
      <BidErrorState
        data-cy="bid-page-error"
        message="Something went wrong loading your Best in Dental history."
        onRetry={() => refetch()}
      />
    );
  }

  return (
    <FixedWidthScreen data-cy="bid-page">
      <Column align="center" gap={4}>
        <Typography variant="h4">Best in Dental</Typography>
        <BidTrophy size="lg" data-cy="bid-trophy-badge" />
        <Typography
          color={colors.text.secondary}
          textAlign="center"
          className={styles.description}
        >
          {PAGE_DESCRIPTION}
        </Typography>
        {toolkitEligible && <WinnersToolkitButton />}
      </Column>

      <TableContainer>
        <Table data-cy="bid-history-table" aria-label="Best in Dental cycle history">
          <TableHead>
            <TableRow>
              <TableCell>Cycle</TableCell>
              <TableCell>Status</TableCell>
              <TableCell aria-label="Actions" />
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <BidHistoryRow
                key={item.cycleId}
                item={item}
                onApply={(cycleId) =>
                  navigate(routes.bestInDentalApplication.replace(':cycleId', cycleId))
                }
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPages > 1 && (
        <Row justify="center">
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </Row>
      )}
    </FixedWidthScreen>
  );
};

export default BidPage;
